import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/MAIN_LOGO_3.png";
import short_logo from "../assets/dent-fav.png";
import user_icon from "../assets/user_img.jpg";
import toast from "react-hot-toast";
import { changePasswordApi } from "../helper/api_helper";

const MasterLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [sidebarActive, setSidebarActive] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [isChangePasswordOpen, setIsChangePassword] = useState(false);

  const [old_password, setOldPassword] = useState("");
  const [new_password, setNewPassword] = useState("");

  // =============================
  // Admin Data
  // =============================
  let admin_data = JSON.parse(localStorage.getItem("adminData"));

  let username = "";
  let email = "";
  let role = "";

  if (admin_data) {
    username = admin_data.username;
    email = admin_data.email;
    role = admin_data.role;
  }

  const isAuthor = role === "AUTHOR";

  // =============================
  // Sidebar Dropdown Logic
  // =============================
  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();

      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");

      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");

        const submenu = dropdown.querySelector(".sidebar-submenu");

        if (submenu) submenu.style.maxHeight = "0px";
      });

      if (!isActive) {
        clickedDropdown.classList.add("open");

        const submenu = clickedDropdown.querySelector(".sidebar-submenu");

        if (submenu) submenu.style.maxHeight = `${submenu.scrollHeight}px`;
      }
    };

    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  // =============================
  // Logout
  // =============================
  const handleLogOutClick = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  // =============================
  // Change Password
  // =============================
  const handleUpdatePassword = async () => {
    if (!old_password || !new_password) {
      toast.error("Please fill all fields");
      return;
    }

    const toastId = toast.loading("Updating password...");

    try {
      const body = {
        email,
        oldPassword: old_password,
        newPassword: new_password,
      };

      await changePasswordApi(body);

      toast.success("Password updated", { id: toastId });

      setOldPassword("");
      setNewPassword("");
      setIsChangePassword(false);
    } catch (error) {
      toast.error("Something went wrong", { id: toastId });
    }
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay"}>
      {/* =============================
          Sidebar
      ============================== */}
      <aside
        className={
          sidebarActive
            ? "sidebar active"
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={() => setMobileMenu(!mobileMenu)}
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>

        {/* Logo */}
        <Link
          to="/dashboard"
          className="sidebar-logo"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <img src={logo} alt="logo" />
        </Link>

        {/* =============================
            Sidebar Menu
        ============================== */}
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu">

            {/* Dashboard (Hidden for AUTHOR) */}
            {!isAuthor && (
              <li>
                <NavLink to="/dashboard">
                  <Icon
                    icon="solar:home-smile-angle-outline"
                    className="menu-icon"
                  />
                  <span>Dashboard</span>
                </NavLink>
              </li>
            )}

            {/* =============================
                BLOGS (Visible for all)
            ============================== */}
            <li className="dropdown">
              <Link to="#">
                <Icon
                  icon="mdi:file-document-edit-outline"
                  className="menu-icon"
                />
                <span>Blogs</span>
              </Link>

              <ul className="sidebar-submenu">
                <li>
                  <NavLink to="/blog-category">Blog Category</NavLink>
                </li>

                <li>
                  <NavLink to="/blog-tags">Blog Tags</NavLink>
                </li>

                <li>
                  <NavLink to="/create-blog">Create Blog</NavLink>
                </li>

                <li>
                  <NavLink to="/blog">Published Blogs</NavLink>
                </li>
              </ul>
            </li>

            {/* =============================
                Other Menus (Hide for AUTHOR)
            ============================== */}
            {!isAuthor && (
              <>
                <li className="dropdown">
                  <Link to="#">
                    <Icon
                      icon="mdi:package-variant-closed"
                      className="menu-icon"
                    />
                    <span>Product Management</span>
                  </Link>

                  <ul className="sidebar-submenu">
                    <li>
                      <NavLink to="/product-category">
                        Product Category
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to="/create-product">
                        Create Product
                      </NavLink>
                    </li>

                    <li>
                      <NavLink to="/published-products">
                        Published Products
                      </NavLink>
                    </li>
                  </ul>
                </li>

                <li>
                  <NavLink to="/slider-management">
                    <Icon
                      icon="mdi:view-carousel-outline"
                      className="menu-icon"
                    />
                    <span>Slider Management</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/conatct-inquiry">
                    <Icon icon="mdi:email-outline" className="menu-icon" />
                    <span>Contact Inquiry</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/product-inquiry">
                    <Icon icon="mdi:email-outline" className="menu-icon" />
                    <span>Product Inquiry</span>
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </div>
      </aside>

      {/* =============================
          Main Content
      ============================== */}
      <main className={sidebarActive ? "dashboard-main active" : "dashboard-main"}>
        {/* Navbar */}
        <div className="navbar-header">
          <div className="d-flex justify-content-between align-items-center">

            <button
              className="sidebar-toggle"
              onClick={() => setSidebarActive(!sidebarActive)}
            >
              <Icon icon="heroicons:bars-3-solid" />
            </button>

            {/* User Menu */}
            <div className="dropdown">
              <button
                className="rounded-circle"
                data-bs-toggle="dropdown"
              >
                <img
                  src={user_icon}
                  alt="user"
                  className="w-40-px h-40-px rounded-circle"
                />
              </button>

              <div className="dropdown-menu dropdown-menu-sm">

                <div className="p-3">
                  <h6>{username}</h6>
                  <span>Admin</span>
                </div>

                <button
                  className="dropdown-item"
                  onClick={() => setIsChangePassword(true)}
                >
                  Change Password
                </button>

                <button
                  className="dropdown-item"
                  onClick={handleLogOutClick}
                >
                  Log Out
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Page Content */}
        <div className="dashboard-main-body">{children}</div>
      </main>

      {/* =============================
          Change Password Modal
      ============================== */}
      {isChangePasswordOpen && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5>Change Password</h5>

                <button
                  className="btn-close"
                  onClick={() => setIsChangePassword(false)}
                />
              </div>

              <div className="modal-body">

                <input
                  type="password"
                  placeholder="Old Password"
                  className="form-control mb-3"
                  value={old_password}
                  onChange={(e) => setOldPassword(e.target.value)}
                />

                <input
                  type="password"
                  placeholder="New Password"
                  className="form-control"
                  value={new_password}
                  onChange={(e) => setNewPassword(e.target.value)}
                />

              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setIsChangePassword(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  onClick={handleUpdatePassword}
                >
                  Update
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default MasterLayout;